import { combineReducers } from 'redux';
import { get } from 'lodash';

import { RECEIVE_VIDEO_SOURCE, RECEIVE_MEDIA_SOURCE, SET_PLAYBACK_URL } from '../../actions/ActionTypes';
import { getMedia } from '../../utils/ASVPUtils';

/* VIDEO SOURCE DATA */
// metadata about the video playing -- titles, types, ids, and images

const authReducer = (state = null, action) => {
    switch (action.type) {
        case RECEIVE_VIDEO_SOURCE:
            return action.payload.data.video.auth;
        default:
            return state;
    }
};


const collectionTitleReducer = (state = null, action) => {
    switch (action.type) {
        case RECEIVE_VIDEO_SOURCE:
            return action.payload.data.video.collection_title;
        default:
            return state;
    }
};


const titleReducer = (state = null, action) => {
    switch (action.type) {
        case RECEIVE_VIDEO_SOURCE:
            return action.payload.data.video.title;
        default:
            return state;
    }
};


const titleIdReducer = (state = null, action) => {
    switch (action.type) {
        case RECEIVE_VIDEO_SOURCE:
            return get(action.payload.data.video, 'title_id', null);
        default:
            return state;
    }
};


const launchDateReducer = (state = null, action) => {
    switch (action.type) {
        case RECEIVE_VIDEO_SOURCE:
            const launchDate = action.payload.data.video.launch_date;
            const authLaunchDate = action.payload.data.video.auth_launch_date;

            return (action.payload.data.video.auth) ? authLaunchDate : launchDate;
        default:
            return state;
    }
};


const typeReducer = (state = null, action) => {
    switch (action.type) {
        case RECEIVE_VIDEO_SOURCE:
            return action.payload.data.video.type;
        default:
            return state;
    }
};


const idReducer = (state = null, action) => {
    switch (action.type) {
        case RECEIVE_VIDEO_SOURCE:
            return action.payload.data.video.id;
        default:
            return state;
    }
};


const posterReducer = (state = null, action) => {
    switch (action.type) {
        case RECEIVE_VIDEO_SOURCE:
            return action.payload.data.video.poster;
        default:
            return state;
    }
};


const disableAdsReducer = (state = null, action) => {
    switch (action.type) {
        case RECEIVE_VIDEO_SOURCE:
            return get(action.payload.data.video, 'disable_ads', null);
        default:
            return state;
    }
};

/* MEDIA SOURCE DATA */
// Includes data about the media itself - duration, media url, whether or not it has captions, and whether it requires cdn token service for playback


const mediaIdReducer = (state = null, action) => {
    switch (action.type) {
        case RECEIVE_MEDIA_SOURCE:
            return action.payload.mediaId;
        default:
            return state;
    }
};


const durationReducer = (state = null, action) => {
    switch (action.type) {
        case RECEIVE_MEDIA_SOURCE:
            const media = getMedia(action.payload);
            return media.totalRuntime;
        default:
            return state;
    }
};


const contentURLReducer = (state = null, action) => {
    switch (action.type) {
        case RECEIVE_MEDIA_SOURCE:
            const media = getMedia(action.payload);
            return media.secureUrl;
        default:
            return state;
    }
};


const hasCaptionsReducer = (state = null, action) => {
    switch (action.type) {
        case RECEIVE_MEDIA_SOURCE:
            const media = getMedia(action.payload);
            return !!media.captions && !!media.captions.length;
        default:
            return state;
    }
};


const playbackURLReducer = (state = null, action) => {
    switch (action.type) {
        case SET_PLAYBACK_URL:
            return action.payload;
        default:
            return state;
    }
};


export default combineReducers({
    auth: authReducer,
    collectionTitle: collectionTitleReducer,
    duration: durationReducer,
    id: idReducer,
    poster: posterReducer,
    contentURL: contentURLReducer,
    playbackURL: playbackURLReducer,
    title: titleReducer,
    titleId: titleIdReducer,
    mediaId: mediaIdReducer,
    launchDate: launchDateReducer,
    type: typeReducer,
    hasCaptions: hasCaptionsReducer,
    disableAds: disableAdsReducer,
});


// WEBPACK FOOTER //
// ./src/player/videoSource/reducer.js